export default __webpack_public_path__ + "static/media/voltage_supervisors.1a431745.svg";